<template>
  <div class="settings-rules" data-testid="settings-rules">
    <!-- Tabs -->
    <div class="sr-tabs" role="tablist">
      <button
        v-for="(tab, i) in tabs"
        :key="tab.key"
        class="sr-tab"
        :class="{ 'sr-tab--active': activeTab === i }"
        role="tab"
        :aria-selected="activeTab === i"
        @click="activeTab = i"
      >
        {{ tab.label }}
      </button>
    </div>

    <!-- Tab content -->
    <div class="sr-content" role="tabpanel">
      <!-- How It Works -->
      <template v-if="activeTab === 0">
        <div v-for="(section, i) in STRINGS.tutorial.codex.howItWorks" :key="i" class="sr-section">
          <h3 class="sr-heading">{{ section.heading }}</h3>
          <ul class="sr-bullets">
            <li v-for="bullet in section.bullets" :key="bullet">{{ bullet }}</li>
          </ul>
        </div>
      </template>

      <!-- Letters -->
      <template v-else-if="activeTab === 1">
        <div v-for="(section, i) in STRINGS.tutorial.codex.letters" :key="i" class="sr-section">
          <h3 class="sr-heading">{{ section.heading }}</h3>
          <ul class="sr-bullets">
            <li v-for="bullet in section.bullets" :key="bullet">{{ bullet }}</li>
          </ul>
        </div>
      </template>

      <!-- Scoring -->
      <template v-else-if="activeTab === 2">
        <div v-for="(section, i) in STRINGS.tutorial.codex.scoring" :key="i" class="sr-section">
          <h3 class="sr-heading">{{ section.heading }}</h3>
          <ul class="sr-bullets">
            <li v-for="bullet in section.bullets" :key="bullet">{{ bullet }}</li>
          </ul>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import STRINGS from '@/constants/strings';

const tabs = [
  { key: 'howItWorks', label: STRINGS.tutorial.codex.tabs.howItWorks },
  { key: 'letters', label: STRINGS.tutorial.codex.tabs.letters },
  { key: 'scoring', label: STRINGS.tutorial.codex.tabs.scoring },
];

const activeTab = ref(0);
</script>

<style scoped>
.settings-rules {
  display: flex;
  flex-direction: column;
}

.sr-tabs {
  display: flex;
  border-bottom: 1px solid var(--color-arena-border);
  margin: 0 -1.25rem;
  padding: 0 1.25rem;
}

.sr-tab {
  flex: 1;
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  color: var(--color-arena-text-muted);
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  padding: 0.6rem 0.5rem;
  transition:
    color 150ms,
    border-color 150ms;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: -1px;
}

.sr-tab--active {
  color: var(--color-arena-text-bright);
  border-bottom-color: var(--color-energy-primary);
}

.sr-tab:hover:not(.sr-tab--active) {
  color: var(--color-arena-text-bright);
}

.sr-content {
  padding-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.sr-section {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
}

.sr-heading {
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--color-arena-text-bright);
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.sr-bullets {
  margin: 0;
  padding: 0 0 0 1.1rem;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.sr-bullets li {
  font-size: 0.8rem;
  color: var(--color-arena-text-muted);
  line-height: 1.5;
}
</style>
